export const ru = {
    'banner-default-body':
        'Текст вашего объявления о рекламе услуги или товара.',
    'banner-default-domain': 'домен',
    'banner-default-title': 'Заголовок объявления'
};
